// extracted by mini-css-extract-plugin
module.exports = {"tabContent":"CT1ZOlX6","wrapper":"NRy3nsVM","tableWrapper":"BzEVvMJl","tableLoaderWrapper":"tJSuh_qc","assetCell":"MSYVgP6C","cellWithChartContainer":"tNCn79D4"};